import React from 'react';
import { useTranslation } from "react-i18next";
import { FaSearchMinus, FaBolt, FaBalanceScale, FaShieldAlt, FaChartLine } from 'react-icons/fa';
import AnimateOnScroll from './AnimateOnScroll';

const Success = () => {
    const { t } = useTranslation();

    const outcomes = [
        { icon: <FaSearchMinus size={18} />, key: 'outcome1' },
        { icon: <FaBolt size={18} />, key: 'outcome2' },
        { icon: <FaBalanceScale size={18} />, key: 'outcome3' },
        { icon: <FaShieldAlt size={18} />, key: 'outcome4' },
        { icon: <FaChartLine size={18} />, key: 'outcome5' },
    ];

    return (
        <section className="py-20" style={{ background: '#f8f9fe' }} id="outcomes">
            <div className="container">
                <AnimateOnScroll>
                    <div className="text-center mb-14">
                        <p className="t-h1">{t("Success.label")}</p>
                        <h2 className="t-h2 max-w-2xl mx-auto">{t("Success.title")}</h2>
                        <p className="t-p max-w-xl mx-auto">{t("Success.subtitle")}</p>
                    </div>
                </AnimateOnScroll>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {outcomes.map((item, key) => (
                        <AnimateOnScroll key={key} animation="fadeUp" delay={key * 80}>
                            <div
                                className="p-6 rounded-2xl border transition-all duration-300 hover:shadow-md hover:-translate-y-0.5 h-full bg-white"
                                style={{ borderColor: '#e5e7eb' }}
                            >
                                <div
                                    className="w-10 h-10 rounded-lg flex items-center justify-center mb-4"
                                    style={{ background: '#f0f2ff', color: '#010C66' }}
                                >
                                    {item.icon}
                                </div>
                                <h3
                                    className="font-bold mb-2"
                                    style={{
                                        fontFamily: '"Wix Madefor Display", sans-serif',
                                        fontSize: '1rem',
                                        color: '#010C66',
                                    }}
                                >
                                    {t(`Success.${item.key}.title`)}
                                </h3>
                                <p style={{ color: '#6b7280', fontSize: '0.875rem', lineHeight: 1.6 }}>
                                    {t(`Success.${item.key}.description`)}
                                </p>
                            </div>
                        </AnimateOnScroll>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Success;
